export default {
    AE: 'UAE',
    BO: 'Bolivia',
    CD: 'Kongo',
    CF: 'Den sentralafrikanske republikk',
    FK: 'Falklandsøyene',
    FM: 'Mikronesia',
    GB: 'Storbritannia',
    GS: 'SGSSI',
    IO: 'BIOT',
    IR: 'Iran',
    KP: 'Nord-Korea',
    KR: 'Sør-Korea',
    LA: 'Laos',
    MD: 'Moldova',
    MF: 'Saint Martin',
    PS: 'Palestina',
    RU: 'Russland',
    SX: 'Sint Maarten',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    US: 'USA',
    VE: 'Venezuela',
    VG: 'Jomfruøyene (britisk)',
    VI: 'Jomfruøyene (USA)',
};
